export const cols = [{
	prop: 'customername',
	label: '客户名称',
	width: '180',
	ischoose: true,
	disabled: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'customercode',
	label: '客户编号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'buyername',
	label: '收货人',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'buytel',
	label: '联系电话',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'buyeraddress',
	label: '收货地址',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'shopname',
	label: '店铺名称',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'pcode',
	label: '商品编号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'bigcategoryname',
	label: '店铺级大类',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'smallcategoryname',
	label: '店铺级小类',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'speccode',
	label: '规格编号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'matchcode',
	label: '第三方编号',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'punit',
	label: '基础单位',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'assistunit',
	label: '辅助单位',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'livequantity',
	label: '订单商品数量',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'livemoney',
	label: '订单商品金额',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}
]
